import {
  AllCategoriesIcon,
  EscapeRoomsCategoryIcon,
  HauntsCategoryIcon,
} from "./icons";

export const CATEGORY_ALL = "all";
export const CATEGORY_ESCAPE_ROOM = "escape-room";
export const CATEGORY_HAUNT = "haunt";

export const CATEGORIES = {
  [CATEGORY_ALL]: {
    Icon: AllCategoriesIcon,
    label: "All",
  },
  [CATEGORY_ESCAPE_ROOM]: {
    Icon: EscapeRoomsCategoryIcon,
    label: "Escape rooms",
  },
  [CATEGORY_HAUNT]: {
    Icon: HauntsCategoryIcon,
    label: "Haunts",
  },
};
